const routes = [];

routes.push({
  path: "/tools/tactical",
  name: "tools_tactical",
  component: () => import("../views/tools/Tactical.vue"),
});

export default routes;
